import {Checkbox as MUICheckbox, FormControlLabel}  from '@mui/material';
import { Controller } from "react-hook-form";

const Checkbox = ({field,schema,useFormRef,...props}) => {
  const {control} = useFormRef;
  return (
    <FormControlLabel
      label={schema.fields[field].spec.label}
      control={
        <Controller
          name={field}
          control={control}
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState: { invalid, isTouched, isDirty, error },
            formState,
          }) => (<MUICheckbox
                   onBlur={onBlur}
                   onChange={onChange}
                   checked={Boolean(value)}
                   inputRef={ref}
                   {...props} />)}
        />
      }/>
  );
};

export default Checkbox;
